import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData {
  confirm: boolean;
}

@Component({
  selector: 'app-dialog-confirm-save-programaccrualratesreport',
  templateUrl: './dialog-confirm-save-programaccrualratesreport.component.html',
  styleUrls: ['./dialog-confirm-save-programaccrualratesreport.component.scss']
})
export class DialogConfirmSaveProgramAccrualRatesReportComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogConfirmSaveProgramAccrualRatesReportComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
  }

  Confirm() {
    this.data.confirm = true;
    this.dialogRef.close(this.data);
  }
  Cancel() {
    this.data.confirm = false;
    this.dialogRef.close();
  }

}
